import styles from './sms-cost.module.scss';

interface SmsCostLabelProps {
  label: string;
}

export const SmsCostLabel = ({ label }: SmsCostLabelProps) => <div className={styles.smsCostLine}>{label}</div>;
